import type {
  BlankCanvasDetailsValues,
  DataStoryStepBodyProps,
} from "../../../services/dataStories/dataStoryFlow.types";

export type BlankCanvasDetailsStepProps =
  DataStoryStepBodyProps<BlankCanvasDetailsValues>;

/**
 * Empty form — the registry's `initialValues` for this step. A factory rather
 * than a shared constant so two steps can never alias the same `audiences`
 * array.
 */
export const emptyBlankCanvasDetails = (): BlankCanvasDetailsValues => ({
  name: "",
  goal: "",
  audiences: [],
  audienceDraft: "",
  isAddingAudience: false,
});
